import { render, staticRenderFns } from "./_promptDetails.vue?vue&type=template&id=38b9ef68&"
import script from "./_promptDetails.vue?vue&type=script&lang=js&"
export * from "./_promptDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports